/* Footer Mercado: columnas desplegables en mobile (en desktop quedan abiertas). */
if (!customElements.get('footer-accordion')) {
  class FooterAccordion extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.fm__toggle');
      if (!this.button) return;

      this.onClick = () => {
        const open = this.button.getAttribute('aria-expanded') === 'true';
        this.button.setAttribute('aria-expanded', open ? 'false' : 'true');
      };
      this.button.addEventListener('click', this.onClick);

      // En desktop las columnas siempre estan abiertas: el boton se desactiva
      this.mq = window.matchMedia('(min-width: 750px)');
      this.onChange = () => {
        const desktop = this.mq.matches;
        this.button.disabled = desktop;
        this.button.setAttribute('aria-expanded', desktop ? 'true' : 'false');
      };
      this.mq.addEventListener('change', this.onChange);
      this.onChange();
    }

    disconnectedCallback() {
      if (this.button && this.onClick) this.button.removeEventListener('click', this.onClick);
      if (this.mq && this.onChange) this.mq.removeEventListener('change', this.onChange);
    }
  }

  customElements.define('footer-accordion', FooterAccordion);
}